module.exports = __webpack_public_path__ + "assets/img/94962002721fcc555c8e02eeb0b810f8.svg";